import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../config";

const deleteInvoiceSchedule = async (scheduleId: number) => {
    const response = await api({
        method: "DELETE",
        url: `/items/scheduled_invoices/${scheduleId}`,
    });

    return response.data;
};

export const useDeleteInvoiceSchedule = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (scheduleId: number) => deleteInvoiceSchedule(scheduleId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scheduled-invoices"] });
        },
    });
};

